import { isFunction, isNull, isString, isUndefined } from 'lodash';

function isDefined(value) {
  return !isNull(value) && !isUndefined(value);
}

function isPresent(value) {
  return isDefined(value) && isString(value) && value.trim() !== '';
}

export default ({ definitions, useInternalFilter }) => {
  const fields = Object.keys(definitions);
  const serializers = {};
  fields.forEach((field) => {
    let serializer = definitions[field];
    if (serializer === true) serializer = value => value;
    if (isFunction(serializer)) {
      serializers[field] = serializer;
    }
  });

  return {
    data() {
      return {
        internalFilter: {},
      };
    },
    computed: {
      filter() {
        const applyFilter = (agg, filter) => {
          fields.forEach((key) => {
            const value = filter[key];
            if (isPresent(value)) agg[key] = value;
          });
          return agg;
        };
        if (useInternalFilter) return applyFilter({}, this.internalFilter);
        return applyFilter({}, this.$route.query);
      },
      filterInfo() {
        const data = {};
        fields.forEach((key) => {
          const serializer = serializers[key];
          const value = this.filter[key];
          if (isDefined(value)) {
            data[key] = serializer(value);
          }
        });
        return data;
      },
    },
    methods: {
      resetInternalFilter() {
        this.internalFilter = {};
      },
      applyFilter(formData) {
        if (useInternalFilter) {
          if (isDefined(this.resetInternalPagination)) {
            this.resetInternalPagination();
          }
          const query = this.applyFormDataToQuery({
            query: this.internalFilter,
            formData,
          });
          this.internalFilter = query;
        } else {
          const query = this.applyFormDataToQuery({
            query: this.$route.query,
            formData,
          });
          this.$router.push({ query });
        }
      },
      applyFormDataToQuery({ query, formData }) {
        const newQuery = { ...query };
        fields.forEach((key) => {
          const value = formData[key];
          if (isPresent(value)) {
            newQuery[key] = value;
          } else {
            delete newQuery[key];
          }
        });
        return newQuery;
      },
    },
  };
};



// WEBPACK FOOTER //
// ./mixins/FilterableView.js